import { Dedicated } from "src/components/cards/dedicated"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"
import { HeroScreen } from "../components/HeroScreen"
import { AssetsContent } from "../components/index/AssetsContent"
import { IndexContent } from "../components/index/IndexContent"
import { InstantPayoutsBlock } from "../components/index/InstantPayoutsBlock"
import { OurCardsBlock } from "../components/index/OurCardsBlock"

export const IndexPage = () => (
  <>
    <div className="main__bg" style={{ overflow: "unset" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, overflow: "hidden" }}>
        <video autoPlay loop muted playsInline poster="img/bg.jpg" className="fullscreen-bg__video">
          <source src="/img/video_bg.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="exchange">
        <Header />
        <HeroScreen />
      </div>
    </div>
    <div className="our-cards">
      <OurCardsBlock />
    </div>
    <Dedicated />
    <InstantPayoutsBlock />

    <AssetsContent />
    <IndexContent />
    <Footer isDark={true} />
  </>
)
